<template>
  <BasicTemplate>
    <h3>
      <router-link to="/games">Games</router-link>
      /
      <router-link :to="`/games/${$route.params.gameId}`">Game #{{ $route.params.gameId }}</router-link>
      /
      Game Meta #{{ $route.params.id }}: {{ item?.name }}
    </h3>
    <Form
      :game="game"
      :item="item"
      @change="save()"
      @change-thumb="load"
    />
  </BasicTemplate>
</template>

<script>
import BasicTemplate from '../../../templates/basic.vue';
import Form from './form.vue';

export default {
  name: 'MetaEdit',
  components: {BasicTemplate, Form},
  data() {
    return {
      game: {},
      item: {},
    };
  },
  async created() {
    this.$watch(() => this.$route.params, (newParams, prevParams) => this.load());
    await this.load();
  },
  methods: {
    async load() {
      const { gameId, id } = this.$route.params;
      this.game = { id: gameId };
      this.item = await this.$gameApi.get(`/games/${gameId}/metas/${id}`);
      // Normalize \n to empty string for text fields when loading data
      const textFields = ['description', 'rules', 'htmlDescription', 'htmlTitle'];
      textFields.forEach(field => {
        if (this.item[field] === '\n') {
          this.item[field] = '';
        }
      });
    },
    async save() {
      try {
        const {gameId, id} = this.$route.params;
        this.item.categories = this.item.categories.map(name => typeof name === 'string' ? ({
          name,
          locale: this.item.locale
        }) : name);
        this.item.tags = this.item.tags.map(name => typeof name === 'string' ? ({
          name,
          locale: this.item.locale
        }) : name);
        this.item.badges = this.item.badges.map(name => typeof name === 'string' ? ({
          name,
          locale: this.item.locale
        }) : name);
        delete this.item.thumbs;
        
        this.item.gameReleaseDate = this.item.gameReleaseDate === '' ? null : this.item.gameReleaseDate;

        // Normalize \n to empty string for text fields
        const textFields = ['description', 'rules', 'htmlDescription', 'htmlTitle'];
        textFields.forEach(field => {
          if (this.item[field] === '\n') {
            this.item[field] = '';
          }
        });

        this.item = await this.$gameApi.patch(`/games/${gameId}/metas/${id}`, this.item);

        this.$swal.fire({icon: 'success', title: 'Game meta saved.', timer: 1500, showConfirmButton: false});
      } catch (e) {
        this.$swal.fire({icon: 'error', title: e.message, timer: 1500, showConfirmButton: false});
      }
    }
  }
};
</script>
